export const CODE_REDEMPTION_REPORT_ACTION = 'CODE_REDEMPTION_REPORT_ACTION'
export const CODE_REDEMPTION_REPORT_ACTION_SUCCESS = 'CODE_REDEMPTION_REPORT_ACTION_SUCCESS'
export const CODE_REDEMPTION_REPORT_ERROR_ACTION = 'CODE_REDEMPTION_REPORT_ERROR_ACTION'

